{
  "Missed calls to WhatsApp": "שיחה שלא נענתה ← וואטסאפ",
  "Text back missed calls": "מענה בוואטסאפ לשיחות שלא נענו",
  "When your phone system reports a call nobody answered, we send the caller a WhatsApp message from your business number. The AI agent then answers, quotes and books as usual.": "כשמערכת הטלפון מדווחת על שיחה שאף אחד לא ענה לה, אנחנו שולחים למתקשר הודעת וואטסאפ מהמספר של העסק. סוכן ה־AI ממשיך משם כרגיל: עונה, נותן הצעת מחיר וקובע תור.",
  "Connect WhatsApp first. Until then, each missed call becomes a call-back task.": "קודם מחברים וואטסאפ. עד אז, כל שיחה שלא נענתה הופכת למשימת התקשרות חוזרת.",
  "Webhook for your phone system": "Webhook למערכת הטלפון",
  "Zapier, Make and most phone systems:": "ל־Zapier, ל־Make ולרוב מערכות הטלפון:",
  "Copy URL": "העתקת הכתובת",
  "Kavkom:": "ל־Kavkom:",
  "Secret. Send it as the header Authorization: Bearer <secret>, or sign the body with it (X-Relayza-Signature). Keep it private.": "מפתח סודי. שולחים אותו בכותרת Authorization: Bearer <secret>, או חותמים איתו על גוף הבקשה (X-Relayza-Signature). לא משתפים אותו.",
  "Show": "הצגה",
  "Copy secret": "העתקת המפתח הסודי",
  "Make a new secret": "יצירת מפתח סודי חדש",
  "Make a new secret? The old one stops working at once, so update your phone system, Zapier or Make right after.": "ליצור מפתח סודי חדש? הקודם יפסיק לעבוד מיד, אז צריך לעדכן מיד אחר כך את מערכת הטלפון, Zapier או Make.",
  "New secret made": "נוצר מפתח סודי חדש",
  "What to send (JSON):": "מה לשלוח (JSON):",
  "Copy example": "העתקת הדוגמה",
  "Inside the 24-hour window: \"Hi, we saw you tried to call and we couldn't pick up. How can we help?\" Outside it, WhatsApp needs an approved template.": "בתוך חלון 24 השעות: \"היי, ראינו שניסית להתקשר ולא הספקנו לענות. במה אפשר לעזור?\" מחוץ לחלון, וואטסאפ דורש תבנית מאושרת.",
  "RELAYZA's template {name}: {status}": "התבנית של RELAYZA ‏{name}: {status}",
  "submitted when you turn this on": "תוגש כשמפעילים את האפשרות",
  "Approved by Meta": "אושרה על ידי Meta",
  "Waiting for Meta's review": "ממתינה לבדיקה של Meta",
  "Rejected by Meta": "נדחתה על ידי Meta",
  "Couldn't be submitted yet": "עדיין לא הצלחנו להגיש אותה",
  "Wait before sending (seconds)": "המתנה לפני שליחה (שניות)",
  "If someone calls them back within this time, nothing is sent.": "אם מישהו חוזר אליהם בזמן הזה, לא נשלח כלום.",
  "One message per caller every (minutes)": "הודעה אחת לכל מתקשר בכל (דקות)",
  "A customer who calls three times gets one message.": "לקוח שמתקשר שלוש פעמים מקבל הודעה אחת.",
  "During quiet hours": "בשעות השקט",
  "Quiet hours are set on the AI agent page. The customer just called, so sending at once is usually right.": "שעות השקט מוגדרות בעמוד סוכן AI. הלקוח הרגע התקשר, אז בדרך כלל נכון לשלוח מיד.",
  "Send anyway": "לשלוח בכל זאת",
  "Wait until quiet hours end": "להמתין לסוף שעות השקט",
  "When WhatsApp can't be used": "כשאי אפשר להשתמש בוואטסאפ",
  "Create a call-back task": "ליצור משימת התקשרות חוזרת",
  "Do nothing": "לא לעשות כלום",
  "Your own phone numbers": "מספרי הטלפון של העסק",
  "Your lines and mobiles, separated by commas. Calls from them are never answered. Staff alert phones are skipped too.": "הקווים והניידים שלכם, מופרדים בפסיקים. לשיחות מהם לא נשלחת הודעה. גם טלפוני ההתראות של הצוות מדולגים.",
  "Your own template (optional)": "תבנית משלכם (לא חובה)",
  "Leave empty to use RELAYZA's template. If you approved your own in WhatsApp Manager, enter its exact name; it must have one variable, your business name.": "משאירים ריק כדי להשתמש בתבנית של RELAYZA. אם אישרתם תבנית משלכם ב־WhatsApp Manager, כותבים את השם המדויק שלה; צריך להיות בה משתנה אחד, שם העסק.",
  "Send a test event": "שליחת אירוע בדיקה",
  "Simulates a missed call from the number you enter, with no wait, even while the switch is off. Use your own mobile to see what customers get. Test calls are left out of reports.": "מדמה שיחה שלא נענתה מהמספר שמזינים, בלי המתנה, גם כשהמתג כבוי. כדאי להזין את הנייד שלכם כדי לראות מה הלקוחות מקבלים. שיחות בדיקה לא נכנסות לדוחות.",
  "Test number": "מספר לבדיקה",
  "Send test event": "שליחת אירוע בדיקה",
  "Sent. Check WhatsApp on that phone.": "נשלח. בדקו את הוואטסאפ בטלפון הזה.",
  "A call-back task was added in Tasks.": "נוספה משימת התקשרות חוזרת במשימות.",
  "Latest calls": "שיחות אחרונות",
  "No missed calls yet.": "עדיין אין שיחות שלא נענו.",
  "Caller": "מתקשר",
  "Details": "פרטים",
  "Withheld": "חסוי",
  "Open chat": "פתיחת השיחה",
  "Call-back task": "משימת התקשרות חוזרת",
  "Missed calls will be texted back": "שיחות שלא נענו יקבלו הודעת וואטסאפ",
  "Missed call text-back turned off": "המענה לשיחות שלא נענו כובה",
  "Texted": "נשלחה הודעה",
  "Missed calls texted back": "שיחות שלא נענו שהוחזרו",
  "missed calls": "שיחות שלא נענו",
  "texted back": "קיבלו הודעה",
  "replied": "ענו",
  "bookings": "תורים",
  "booked, in value": "שווי התורים",
  "Bookings these customers made after the message, valued like Booked by AI: the price on confirmed and attended visits.": "תורים שהלקוחות האלה קבעו אחרי ההודעה, בשווי שמחושב כמו \"נקבע ע״י AI\": המחיר של תורים מאושרים ושל ביקורים שהתקיימו.",
  "Missed Call Text-Back is off": "המענה לשיחות שלא נענו כבוי",
  "Withheld or anonymous number": "מספר חסוי או אנונימי",
  "Not a phone number WhatsApp can reach": "זה לא מספר שוואטסאפ יכול להגיע אליו",
  "One of the business's own numbers": "אחד המספרים של העסק",
  "A staff alert phone": "טלפון התראות של הצוות",
  "A number marked personal": "מספר שסומן כפרטי",
  "Already texted this caller recently": "כבר נשלחה הודעה למתקשר הזה לאחרונה",
  "The call was too long ago": "השיחה הייתה לפני יותר מדי זמן",
  "The call was answered or returned in time": "ענו לשיחה או חזרו ללקוח בזמן",
  "Already in touch on WhatsApp": "כבר בקשר בוואטסאפ",
  "Outside the 24h window and no approved template": "מחוץ לחלון 24 השעות ואין תבנית מאושרת",
  "Automated messages are paused": "ההודעות האוטומטיות מושהות",
  "Quiet hours": "שעות שקט",
  "The business is closed today": "העסק סגור היום",
  "Daily limit for automated messages reached": "הגעתם למכסה היומית של הודעות אוטומטיות",
  "Interrupted while sending": "השליחה נקטעה"
}
